/* eslint-disable import/prefer-default-export */
import { palette } from './color';

export const shadow = {
  focus: `0 0 2px 0 ${palette.mango}`,
  focusInput: `0 0 0 1px ${palette.white}, 0 0 3px 3px rgba(0, 102, 192, 0.5), 0 0 0 2px ${palette.auiblue}`,
};
